import request from './request'

export const offerManageApi = {
  listOfferManage (params) {
    return request.get('/offers', { params: params })
  },
  saveOfferManage (data) {
    return request.post('/offer', data)
  },
  deleteOfferManage (id) {
    return request.delete('/offers/' + id)
  },
  getOfferManage (id) {
    return request.get('/offers/' + id)
  },
  updateOfferManage (id, data) {
    return request.put('/offers/' + id, data)
  },
}

export default offerManageApi
